<template>
  <v-container>
    <v-row>
      <h1>Employee Directory</h1>
    </v-row>
    <v-card shaped v-if="this.employees.length === 0">
      <v-row class="d-flex justify-center">
        <v-col class="pt-5 mt-5">
          <v-skeleton-loader type="table"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card>
    <v-row v-else>
      <v-col cols="12">
        <v-card shaped>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col>
                <v-row class="d-flex justify-space-between align-center">
                  <v-col cols="8">
                    <router-link 
                      v-if="userIsAdmin" 
                      :to="{ name: 'Upload Employees' }"
                    >
                      <v-btn rounded text>
                        <v-icon left>mdi-cloud-upload</v-icon>
                        Upload Employees
                      </v-btn>
                    </router-link>
                    <EmployeeForm 
                      method="create" 
                      methodTitle="Create Employee"
                      icon="mdi-plus"
                      textBtn
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      class="pb-5"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col>
                <v-data-table
                  :headers="headers"
                  :items="employees"
                  :search="search"
                >
                  <template v-slot:item.avatar="{ item }" >
                    <Avatar :employee="item" :size="30" :hideHeadline="true" />
                  </template>
                  <template v-slot:item.searchableText="{ item }" >
                    <router-link 
                      :to="{ name: 'Employee', params: { id: item.id } }"
                    >
                    {{ item.fields.Name }}
                    </router-link>
                  </template>
                  <template v-slot:item.isInactive="{ item }">
                    <v-simple-checkbox 
                      v-model="item.isInactive"
                      @click="toggleActivation(item)"
                      :ripple="false"
                      :disabled="disableCheckboxes"
                    ></v-simple-checkbox>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col class="text-end">
                <small>
                  <em>
                    Employees inactivated here will remain inactive regardless of future uploads
                  </em>
                </small>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Avatar from '@/components/employee/Avatar'
  import EmployeeForm from '@/components/employee/Form'
  import User from '@/mixins/User'
  
  export default {
    name: 'EmployeeDirectory',
    mixins: [ User ],
    components: {
      Avatar,
      EmployeeForm
    },
    data () {
      return {
        disableCheckboxes: false,
        search: '',
        headers: [
          {
            text: '',
            sortable: false,
            value: 'avatar'
          },
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'searchableText'
          },
          {
            text: 'Title',
            align: 'start',
            value: 'fields.Title'
          },
          {
            text: 'Department',
            align: 'start',
            value: 'fields.Department'
          },
          {
            text: 'Location',
            align: 'start',
            value: 'fields.Location Formatted'
          },
          {
            text: 'Inactive',
            align: 'center',
            value: 'isInactive'
          }
        ]
      }
    },
    computed: {
      employees () {
        return this.$store.getters.getEmployees.slice(0).sort((a, b) => {
          return a.fields.Name > b.fields.Name ? 1 : -1
        }).map(e => {
          e.isInactive = e.fields.Status === 'Inactive'
          e.searchableText = `${e.fields.Name} ${e.fields.Email}`
          return e
        })
      }
    },
    created () {
      this.$store.dispatch('getRecords', {
        table: 'Employees',
        view: 'All Employees',
        dispatch: 'setEmployees'
      })
    },
    methods: {
      toggleActivation (employee) {
        const newStatus = employee.isInactive ? 'Inactive' : 'Active'
        const that = this
        that.disableCheckboxes = true
        let fields = {
          'Status': newStatus
        }
        if (newStatus === 'Inactive') {
          fields['Ignore In Upload'] = true
        } else {
          fields['Ignore In Upload'] = false
        }
        this.$store.dispatch('updateRecords', {
          table: 'Employees',
          records: [{
            id: employee.id,
            fields: fields
          }]
        })
        .then(() => {
          this.$store.dispatch('getRecords', {
            table: 'Employees',
            view: 'All Employees',
            dispatch: 'setEmployees'
          })
          .then(() => {
            that.disableCheckboxes = false
          })
        })
      }
    }
  }
</script>
